import { promisify } from "./utils/Promisify";

function logoutFnDescriptor(
  switchValue: string,
  executeCondition: string,
  triggerSetting: string,
  debounceAndThrottleTime: number,
) {
  return {
    type: "LOGOUT" as const,
    payload: {
      switchValue,
      executeCondition,
      triggerSetting,
      debounceAndThrottleTime,
    },
  };
}

export type TLogoutArgs = Parameters<typeof logoutFnDescriptor>;
export type TLogoutDescription = ReturnType<typeof logoutFnDescriptor>;
export type TLogoutActionType = TLogoutDescription["type"];

async function logout(...args: TLogoutArgs) {
  return promisify(logoutFnDescriptor)(...args);
}

export default logout;
